import React from 'react'

function HomeContent() {
  return (
    <>
      <div className='container'>
        <div className='row'>
            <div className='col-md-12'>
                <h1 className='heading'>OMOTENASHI</h1>
                <p className='content'>"Omotenashi” is a culture of welcoming guests that has been cherished in Japan since ancient times. For example, when you’re visiting someone’s house, wouldn’t it make you very happy if they had your favorite flowers on display? This is our way of welcoming people who has travelled a long way to see you, to bring joy to them as much as possible. That is “Omotenashi”</p>
            </div>
        </div>
      </div>
    </>
  )
}

export default HomeContent
